const ratingHandler = (starsContainer) => {
    const starsLight = [...starsContainer.querySelectorAll('.star-light')];
    const starsSolid = [...starsContainer.querySelectorAll('.star-solid')];

    const ratingInput = starsContainer.querySelector('.js-rating-input');

    let rating = 0;
    let ratingSet = false;

    const setRating = (rate) => {
        rating = rate + 1;
        ratingInput.value = rating;

        ratingSet = true;
    };

    const resetStars = () => {
        starsLight.forEach((el) => {
            el.classList.remove('d-none');
        });
        starsSolid.forEach((el) => {
            el.classList.add('d-none');
        });
    };

    const changeRating = (rate) => {
        rating = rate;

        resetStars();

        starsLight
            .filter((el) => Number(el.dataset.index) <= rating)
            .forEach((el) => {
                el.classList.add('d-none');
            });

        starsSolid
            .filter((el) => Number(el.dataset.index) <= rating)
            .forEach((el) => {
                el.classList.remove('d-none');
            });
    };

    starsLight.forEach((star) => {
        star.addEventListener('mouseenter', () => {
            changeRating(Number(star.dataset.index));
        });
    });

    starsSolid.forEach((star) => {
        star.addEventListener('mouseenter', () => {
            changeRating(Number(star.dataset.index));
        });

        star.addEventListener('click', () => {
            setRating(Number(star.dataset.index));
        });
    });

    starsContainer.addEventListener('mouseleave', () => {
        if (!ratingSet) {
            changeRating(-1);
        }
    });
};

export const ratingListener = () => {
    const starsContainers = [...document.querySelectorAll('.js-rating')].filter(
        (el) => !el.dataset.ratingInitialized
    );

    starsContainers.forEach((starsContainer) => {
        ratingHandler(starsContainer);

        starsContainer.dataset.ratingInitialized = true;
    });
};
